export default __webpack_public_path__ + "static/media/open-in-new.cf9d7180.svg";